import app from '../app.first';
import $ from 'jquery';

app.PreventMutlipleSubmissions = class extends app.Component {
    onReady() {
        this.$el.find('form').on('formvalid.zf.abide', function () {
            $(".button-dprimary").attr('disabled','disabled');
        });
    }
}